import React from "react";
import Typography from "@material-ui/core/Typography";
import Image from "react-bootstrap/Image";
import { toAbsoluteUrl } from "../../../../../../../_metronic";
const Team = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Team
      </Typography>
      <Typography paragraph variant="h5">
        An overview of the Invifo founders and the core team.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo is developed and maintained by a group of invaluable core company
        members who share the same passion and vision. The duos founders have
        more than ten years of experience as an ERP consultant before deciding
        to have their own masterpiece. With the massive support of the core
        teams and the valuable feedback of the customers, Invifo will evolve
        continuously.
      </Typography>
      <div className="row justify-content-center mt-5">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              <Typography component="span" align="center">
                <Image
                  src={toAbsoluteUrl(
                    `/invifo/teams/ArthaPradyta_Founder_ExecutiveChairman.jpg`
                  )}
                  style={{
                    maxHeight: "150px",
                  }}
                  alt="Avatar"
                  roundedCircle
                  fluid
                />
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Artha Pradyta
              </Typography>
              <Typography align="center">
                Founder, Executive Chairman
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              <Typography component="span" align="center">
                <Image
                  src={toAbsoluteUrl(
                    `/invifo/teams/AdityaPrawira_ChiefExecutiveOfficer.jpg`
                  )}
                  style={{
                    maxHeight: "150px",
                  }}
                  alt="Avatar"
                  roundedCircle
                  fluid
                />
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Aditya Prawira
              </Typography>
              <Typography align="center">
                Founder, Chief Executive Officer
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              <Typography component="span" align="center">
                <Image
                  src={toAbsoluteUrl(
                    `/invifo/teams/RiyanBagaskara_ChiefTechnologyOfficer.jpg`
                  )}
                  style={{
                    maxHeight: "150px",
                  }}
                  alt="Avatar"
                  roundedCircle
                  fluid
                />
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Riyan Bagaskara
              </Typography>
              <Typography align="center">Chief Technology Officer</Typography>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Team;
